import { useLazyQuery } from 'apollo-3';
import { useMemo } from 'react';

import { getMPMyProgressTracker } from 'GraphQL/query/MyPath.query';

const useGetPreviousMyProgressTracker = (props) => {
  // NOTE: The date is needed to be memoized to prevent an infinite loop.
  const date = useMemo(() => {
    return new Date().toISOString();
  }, []);

  const [getPreviousMyProgressTracker, { data, loading, error, networkStatus, ...apolloUtils }] =
    useLazyQuery(getMPMyProgressTracker, {
      variables: { date, option: { previousSemesterOffset: 1 } },
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      ...props,
    });

  return {
    getPreviousMyProgressTracker,
    mpPreviousMyProgressTracker: data?.mpMyProgressTracker,
    loading,
    error,
    ...apolloUtils,
  };
};

export default useGetPreviousMyProgressTracker;
